import { createContext, useContext } from 'react';

/**
 * Run-level provenance for the dossier result page — WHEN it was generated
 * (the run's real completion time) and WHO ran it (operator display name).
 *
 * Provided ONCE at the result route from the outer run detail, so every
 * per-country header can show it without prop-drilling through the various
 * per-country view components. Headers read it via {@link useDossierRunProvenance}.
 */
export interface DossierRunProvenance {
  /** Run's real completion time (ISO). Null on legacy / in-flight runs. */
  generatedAt: string | null;
  /** Operator display name, resolved server-side. Null when unknown. */
  generatedBy: string | null;
}

export const DossierRunProvenanceContext = createContext<DossierRunProvenance>({
  generatedAt: null,
  generatedBy: null,
});

export function useDossierRunProvenance(): DossierRunProvenance {
  return useContext(DossierRunProvenanceContext);
}
